import { MessageSquare, User, Users, LogOut, Star } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import FavoritesModal from "../chat/FavoritesModal";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [favoritesOpen, setFavoritesOpen] = useState(false);
  const [favHover, setFavHover] = useState(false);

  const Item = ({ icon: Icon, path, label, onClick }) => {
    const [hover, setHover] = useState(false);
    const isActive = location.pathname === path;

    const user = localStorage.getItem("user");

    return (
      <>
        <div
          style={{
            ...styles.item,
            ...(isActive ? styles.active : {}),
          }}
          onClick={onClick}
          onMouseEnter={(e) => {
            setHover(true);
            if (!isActive) {
              e.currentTarget.style.background = "rgba(255,255,255,0.08)";
              e.currentTarget.style.color = "#fff";
            }
          }}
          onMouseLeave={(e) => {
            setHover(false);
            if (!isActive) {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = "#aaa";
            }
          }}
        >
          <Icon size={22} />

          <div
            style={{
              ...styles.tooltip,
              opacity: hover ? 1 : 0,
              transform: hover
                ? "translateY(-50%) translateX(0)"
                : "translateY(-50%) translateX(-6px)",
            }}
          >
            {label}
          </div>
        </div>

        <div style={styles.divider} />
      </>
    );
  };

  return (
    <>
      <div style={styles.sidebar}>
        <div style={styles.menu}>

          {/* 🔥 ЦЕНТР */}
          <div style={styles.centerBlock}>
            <Item
              icon={MessageSquare}
              path="/chats"
              label="Сообщения"
              onClick={() => navigate("/chats")}
            />

            <Item
              icon={User}
              path="/profile"
              label="Профиль"
              onClick={() => navigate("/profile")}
            />

            <Item
              icon={Users}
              path="/contacts"
              label="Контакты"
              onClick={() => navigate("/contacts")}
            />

            <Item
              icon={LogOut}
              label="Выйти"
              onClick={() => {
                localStorage.removeItem("user");
                navigate("/");
              }}
            />
          </div>

          {/* ⭐ НИЗ */}
          <div style={styles.bottomBlock}>
            <div
              style={{
                ...styles.item,
                opacity: 0.55,
                transform: "scale(0.9)",
              }}
              onClick={() => setFavoritesOpen(true)}
              onMouseEnter={(e) => {
                setFavHover(true);
                e.currentTarget.style.opacity = 1;
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.background = "rgba(255,255,255,0.08)";
              }}
              onMouseLeave={(e) => {
                setFavHover(false);
                e.currentTarget.style.opacity = 0.55;
                e.currentTarget.style.transform = "scale(0.9)";
                e.currentTarget.style.background = "transparent";
              }}
            >
              <Star size={20} />

              <div
                style={{
                  ...styles.tooltip,
                  opacity: favHover ? 1 : 0,
                  transform: favHover
                    ? "translateY(-50%) translateX(0)"
                    : "translateY(-50%) translateX(-6px)",
                }}
              >
                Избранное
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ✅ МОДАЛКА */}
      {favoritesOpen && (
  <FavoritesModal
    onClose={() => setFavoritesOpen(false)}
    onJumpToMessage={(chatId, messageId) => {
      navigate("/chats", {
        state: {
          chatId: chatId,
          jump: {
            chatId: chatId,
            msg: messageId
          }
        }
      });
    }}
  />
)}

    </>
  );
}

const styles = {
  sidebar: {
    width: 72,
    height: "100vh",
    background: "#0a0a0a",
    display: "flex",
    justifyContent: "center",
    borderRight: "1px solid rgba(255,255,255,0.04)",
  },

  menu: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
  },

  centerBlock: {
    margin: "auto 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
  },

  bottomBlock: {
    marginBottom: 20,
  },

  item: {
    position: "relative",
    width: 44,
    height: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 12,
    cursor: "pointer",
    color: "#aaa",
    transition: "all 0.2s ease",
  },

  active: {
    background: "rgba(255,255,255,0.12)",
    color: "#fff",
    boxShadow: "0 0 10px rgba(255,255,255,0.15)",
  },

  divider: {
    width: 26,
    height: 1,
    background: "rgba(255,255,255,0.06)",
    margin: "4px 0",
  },

  tooltip: {
    position: "absolute",
    left: 60,
    top: "50%",
    transform: "translateY(-50%)",
    background: "#1e1e1e",
    padding: "6px 10px",
    borderRadius: 8,
    fontSize: 12,
    whiteSpace: "nowrap",
    color: "#fff",
    pointerEvents: "none",
    border: "1px solid rgba(255,255,255,0.1)",
    transition: "all 0.15s ease",
  },
};